<template>
  <div class="screen-main">
    <div class="main-left">
      <div class="main-left-tsec">
        <div class="rescue-progress">
          <div class="bsTitle bsTitle--small">
            <h4 :text="$l('今日救援进度统计')">
              {{ $l("今日救援进度统计") }}
            </h4>
          </div>
          <div class="rescue-view">
            <div class="rescue-items">
              <div class="bsColname">
                {{ $l("故障维修进度") }}
              </div>
              <div class="progress-box">
                <div
                  class="bar-box"
                  v-for="(item, index) in rescueProgress.maintain.number"
                  :key="index"
                >
                  <div class="progress-bar">
                    <screen-circle-half
                      :config="circleConfig"
                      :rate="rescueProgress.maintain.progress[index]"
                    >
                      <span>{{
                        rescueProgress.maintain.progress[index]
                          | progressDecimals
                      }}</span>
                    </screen-circle-half>
                  </div>

                  <div class="text">
                    {{ $l(progressText[index]) }}
                    <em>{{ item }}</em>
                  </div>
                </div>
              </div>
            </div>
            <div class="rescue-items">
              <div class="bsColname">
                {{ $l("困人救援进度") }}
              </div>
              <div class="progress-box">
                <div
                  class="bar-box"
                  v-for="(item, index) in rescueProgress.rescue.number"
                  :key="index"
                >
                  <div class="progress-bar">
                    <screen-circle-half
                      :config="circleConfig2"
                      :rate="rescueProgress.rescue.progress[index]"
                    >
                      <span>{{
                        rescueProgress.rescue.progress[index] | progressDecimals
                      }}</span>
                    </screen-circle-half>
                  </div>

                  <div class="text">
                    {{ $l(progressText2[index]) }}
                    <em>{{ item }}</em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mapAlarmList">
          <div class="mapAlarmList-h">
            <h4 :text="$l('预警数')">{{ $l("预警数") }}</h4>
          </div>
          <div class="warning-list">
            <my-seamless-scroll
              class="seamless-warning"
              ref="warningScroll"
              :data="mapAllScrollData"
              :class-option="{
                step: 0.5,
                limitMoveNum: 16,
                hoverStop: true,
                openWatch: true,
                singleHeight: singleMapHeight,
              }"
            >
              <div
                class="warning-map-item"
                v-for="(item, index) in mapAllCicyData"
                :key="index"
              >
                <h4>{{ item.name | provinceShortName }}</h4>
                <span class="warning-map-item__line"></span>
                <p>
                  <em>{{ item.value }}</em
                  >{{ $l("台") }}
                </p>
              </div>
            </my-seamless-scroll>
          </div>
          <!-- <div class="footer">
              <i @click="cancelShowWarning"></i>
            </div> -->
        </div>
      </div>
      <div class="monitoring-top">
        <div class="bsTitle">
          <h4 :text="$l('昨日遥监预警记录排行')">
            {{ $l("昨日遥监预警记录排行") }}
          </h4>
        </div>
        <div class="top-list">
          <template v-if="monitorWarningTop3.length != 0">
            <div
              v-for="(item, index) in monitorWarningTop3"
              :key="item.domainId"
            >
              <h5>TOP{{ index + 1 }}</h5>
              <span
                >{{ item.city }}, {{ $l("故障台量") }} {{ item.liftCount
                }}{{ $l("台") }}, {{ item.domainName }}</span
              >
              <i
                ><b>{{ item.faultCount }}</b
                >{{ $l("宗") }}
              </i>
            </div></template
          >
          <template v-else>
            <div class="no-data">
              <p>{{ warningtopLoading | emptyOrLoadText($l) }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="main-map">
      <div class="map-fbox" v-screen-loading="mapLoading">
        <div id="tiring-map-box">
          <!-- <span class="map-under" v-if="!window.config.baiduAK"
            >{{ $l("地图维护中...") }}
          </span> -->
        </div>

        <div id="custom-map-info" class="custom-map-info"></div>

        <div class="tiring-map-label" v-if="!mapMaintain">
          <div class="tiring">
            <span> </span>
            <label>{{ $l("困人") }} </label>
          </div>
          <div class="warning">
            <span> </span>
            <label>{{ $l("预警") }} </label>
          </div>
        </div>
      </div>

      <div class="tour-collect">
        <!-- <div class="tip tip-plus tip-right">
          <p>
            <span class="en-class">
              {{ $l("设备巡视汇总") }}
            </span>
            <span
              >{{ $l("单位：") }} <i>{{ $l("台") }} </i></span
            >
          </p>
        </div> -->
        <div class="collect-list">
          <div
            class="collect-item"
            v-for="item in deviceCollects"
            :key="item.icon"
          >
            <div class="number">
              <em>
                <count-to
                  :startVal="0"
                  :endVal="item.number"
                  :duration="3000"
                  :decimals="0"
                >
                </count-to>
              </em>
              <span :data-title="$l(item.title)"></span>
            </div>
            <div class="collect-item-icon">
              <div
                class="icon"
                :style="{
                  backgroundImage: `url(${require(`../../assets/img/largeScreen/${item.icon}.png`)})`,
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-map-fsec">
        <div class="monitoring-top">
          <div class="bsTitle">
            <h4 :text="$l('合同提醒')">
              {{ $l("合同提醒") }}
            </h4>
            <span class="bsTitle-extra">
              {{ $l("时间：") }} <em>{{ $l("三个月内") }} </em>
            </span>
          </div>
          <div class="top-list top-list-contract">
            <template v-if="contractRemindList.length != 0">
              <div v-for="(item, index) in contractRemindList" :key="index">
                <span>
                  <s
                    >{{ item.agreeNum }}·{{ item.city || "--" }}·{{
                      item.domainName || "--"
                    }}</s
                  >
                  <em>·{{ $l("电梯") }} {{ item.utils }} {{ $l("台") }} </em>
                </span>
                <i
                  ><b>{{ item.days }}</b
                  >{{ $l("天") }}
                </i>
              </div>
            </template>
            <template v-else>
              <div class="no-data">
                <p>{{ contractLoading | emptyOrLoadText($l) }}</p>
              </div>
            </template>
          </div>
        </div>
        <div class="monitoring-top">
          <div class="bsTitle">
            <h4 :text="$l('年检提醒')">
              {{ $l("年检提醒") }}
            </h4>
            <span class="bsTitle-extra">
              {{ $l("时间：") }} <em>{{ $l("三个月内") }} </em>
            </span>
          </div>
          <div class="top-list top-list-contract top-list-annual">
            <template v-if="annualExamineRemindList.length != 0">
              <div v-for="item in annualExamineRemindList" :key="item.domainId">
                <span>
                  <s>{{ item.city || "--" }}</s>
                  <em>{{ item.domainName || "--" }}</em>
                </span>
                <i
                  ><b>{{ item.utils }}</b
                  >{{ $l("台") }}
                </i>
              </div>
            </template>
            <template v-else>
              <div class="no-data">
                <p>{{ annualLoading | emptyOrLoadText($l) }}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="main-right">
      <div class="maintain-record" v-screen-loading="calendarLoading">
        <div class="bsTitle">
          <h4 :text="$l('无纸化保养记录')">
            {{ $l("无纸化保养记录") }}
          </h4>
          <div class="change">
            <div class="btn">
              <!-- <svgicon name="date-left" @click="changeDate(0)" /> -->
              <i class="el-icon-arrow-left" @click="changeDate(0)"></i>
              <span
                >{{ calenderDate.y + "." + calenderDate.m }}
                <el-date-picker
                  prefix-icon="none"
                  :clearable="false"
                  class="custom-date-picker"
                  v-model="datePickerValue"
                  popper-class="date-screen"
                  :append-to-body="true"
                  align="center"
                  type="month"
                  placeholder=""
                  @change="changeCalenderDate"
                >
                </el-date-picker
              ></span>
              <!-- <svgicon name="date-right" @click="changeDate(1)" /> -->
              <i class="el-icon-arrow-right" @click="changeDate(1)"></i>
            </div>
          </div>
          <div class="already">
            <span>
              {{ $l("已完成") }}
            </span>
            <span>
              {{ $l("未完成") }}
            </span>
          </div>
        </div>
        <div class="calendar">
          <div class="calendar-title">
            <span v-for="item in calendarTitle" :key="item">{{ item }}</span>
          </div>
          <div class="calendar-table">
            <div
              class="calendar-item"
              v-for="(item, index) in calenderDate.ds"
              :key="index"
              :class="[
                item.notNow ? 'ash' : '',
                calenderDate.y + calenderDate.m + item.dZero ==
                  calenderDate.activateDate && !item.notNow
                  ? 'activate'
                  : '',
              ]"
            >
              <i>{{ item.d }}</i>
              <span>
                <em>{{ item.planOrFinish[0] | maintainRecordSimplify }}</em
                >{{ item.planOrFinish[1] | maintainRecordSimplify }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="degree-pie">
        <div class="bsTitle">
          <h4 :text="$l('运行次数分布统计')">
            {{ $l("运行次数分布统计") }}
          </h4>
        </div>
        <div class="pie">
          <div class="degree-label degree-label--left">
            <div
              v-for="(item, index) in runTimePieData.slice(-3).reverse()"
              :key="index"
            >
              <i :style="{ backgroundColor: item.itemStyle.color }"></i>
              <p>
                <em>{{ item.value | maintainRecordSimplify("0000") }}</em>
                {{ $l("台") }}
              </p>
              <h4>{{ $l(item.name) }}</h4>
            </div>
          </div>
          <div id="degree-pie-id" class="pie-box"></div>
          <div class="degree-label">
            <div
              v-for="(item, index) in runTimePieData.slice(0, 3)"
              :key="index"
            >
              <i :style="{ backgroundColor: item.itemStyle.color }"></i>
              <p>
                <em>{{ item.value | maintainRecordSimplify("0000") }}</em>
                {{ $l("台") }}
              </p>
              <h4>{{ $l(item.name) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="liftage-distribute">
        <div class="bsTitle">
          <h4 :text="$l('梯龄分布')">
            {{ $l("梯龄分布") }}
          </h4>
          <span class="bsTitle-extra">
            {{ $l("单位：") }} <em>{{ $l("台") }} </em>
          </span>
        </div>
        <div class="liftage-custom-box" id="liftage-custom-box"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../plugins/directive.js";
import ScaleBox from "vue2-scale-box";
import * as echarts from "echarts";
import dayjs from "dayjs";
import global from "@/mixins/global.js";
import screenCircleHalf from "../../components/screenCircleHalf.vue";
import "../../../node_modules/echarts/map/js/china.js";
import MySeamlessScroll from "../../components/mySeamlessScroll.vue";
import countTo from "vue-count-to";
import loadBMap from "@/utils/loadBMap";
const PROVINCES = [
  "北京市",
  "天津市",
  "上海市",
  "重庆市",
  "河北省",
  "山西省",
  "内蒙古",
  "辽宁省",
  "吉林省",
  "黑龙江省",
  "江苏省",
  "浙江省",
  "安徽省",
  "福建省",
  "江西省",
  "山东省",
  "河南省",
  "湖北省",
  "湖南省",
  "广东省",
  "广西",
  "海南省",
  "台湾省",
  "四川省",
  "贵州省",
  "云南省",
  "西藏",
  "陕西省",
  "甘肃省",
  "青海省",
  "宁夏",
  "新疆",
  "香港",
  "澳门",
];
export default {
  name: "largeScreen",
  mixins: [global],
  props: {
    screenWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      datePickerValue: null,
      calenderDate: {
        y: null,
        m: null,
        d: null,
        ds: [],
      },
      calendarTitle: [
        "Sun/日",
        "Mon/一",
        "Tue/二",
        "Wed/三",
        "Thu/四",
        "Fri/五",
        "Sat/六",
      ],
      mapMaintain: false,
      runTimePieData: [
        { value: 0, name: "0-50万次", itemStyle: { color: "#8AE4EF" } },
        {
          value: 0,
          name: "50-100万次",
          itemStyle: { color: "#FFCE7F" },
        },
        {
          value: 0,
          name: "100-150万次",
          itemStyle: { color: "#FB5C5D" },
        },
        {
          value: 0,
          name: "150-200万次",
          itemStyle: { color: "#ECF0FF" },
        },
        {
          value: 0,
          name: "200万次以上",
          itemStyle: { color: "#8797FF" },
        },
        { value: 0, name: "未知", itemStyle: { color: "#4268E2" } },
      ],
      calendarLoading: false,
      pieChart: null,
      circleConfig: {
        borderWidth: "0.4vw",
        circleSize: "0",
        startColor: "#EE7683",
        endColor: "#F7CF9C",
        centerCircleBg: "#091838",
        centerLabelColor: "#FFCE7F",
        borderBackground: "rgba(156, 167, 239, 0.2)",
      },
      circleConfig2: {
        borderWidth: "0.4vw",
        circleSize: "0",
        startColor: "#4169F4",
        endColor: "#69D7FA",
        centerCircleBg: "#091838",
        centerLabelColor: "#95D8FF",
        borderBackground: "rgba(156, 167, 239, 0.2)",
      },
      rescueProgress: 0.4,
      deviceCollects: [
        { icon: "collect_icon_01", type: 1, title: "正常运行", number: 0 },
        {
          icon: "collect_icon_02",
          type: 2,
          title: "遥监在线",
          number: 0,
        },
        { icon: "collect_icon_03", type: 3, title: "检修", number: 0 },
        { icon: "collect_icon_04", type: 4, title: "故障停梯", number: 0 },
        { icon: "collect_icon_05", type: 5, title: "困人", number: 0 },
        { icon: "collect_icon_06", type: 0, title: "今日保养", number: 0 },
      ],
      liftageChart: null,
      map: null,
      showWarnings: true,
      lll: "indexBigScreen",
      monitorStatusData: {
        normal: { centage: "0%", value: "0" },
        abnormal: { centage: "0%", value: "0" },
      },
      monitorWarningTop3: [],
      contractRemindList: [],
      annualExamineRemindList: [],
      realTimeFollowList: [],
      singleRealtimeHeight: 0,
      singleMapHeight: 0,
      liftageData: [],
      mapWarningData: [],
      mapTiringData: [],
      mapAllCicyData: [],
      mapAllScrollData: [],
      rangeType: 0,
      districtName: "",
      mapLoading: false,
      rescueProgress: {
        maintain: {
          number: [0, 0, 0, 0],
          progress: [0, 0, 0, 0],
        },
        rescue: {
          number: [0, 0, 0, 0],
          progress: [0, 0, 0, 0],
        },
      },
      warningtopLoading: false,
      contractLoading: false,
      annualLoading: false,
      throttleTimer: null,
      progressText: ["已报修", "已派工", "已到场", "已完工"],
      progressText2: ["已报修", "已派工", "已到场", "已完工"],
    };
  },
  components: {
    ScaleBox,
    screenCircleHalf,
    MySeamlessScroll,
    countTo,
  },
  computed: {},
  filters: {
    maintainRecordSimplify(number, str) {
      number = Number(number);
      let units = [1, 2, 3, 4, 5, 6, 7, 8, 9];
      function num(numstr) {
        let n = "1";
        units.forEach((v) => {
          if (number > v + numstr) {
            n = v;
          }
        });
        return n;
      }
      if (str == "0000") {
        let b = number / 10000;
        return b < 1
          ? number
          : b > 1
          ? parseInt(b, 10) != b
            ? `${parseInt(b, 10)}w+`
            : `${b}w`
          : `${b}w`;
      }
      return number > 9999
        ? `${num("0000")}w+`
        : number > 999
        ? `${num("000")}k+`
        : number;
    },
    progressDecimals(decimals) {
      return (decimals * 100).toFixed(0) + "%";
    },
    emptyOrLoadText(load, $l) {
      return load ? $l("加载中...") : $l("暂无数据");
    },
    provinceShortName(name) {
      name = name.replace(/(壮族|维吾尔|回族|藏族|蒙古族)/g, "");
      return name.replace(/(自治区|省|市|特别行政区)$/, "");
    },
  },
  created() {},
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.calenderDate = this.$common.getCurrentOrRestDate();
      console.log(this.calenderDate);
      this.statisticsMonitorStatusCount();
      this.getMonitorWarningTop();
      this.getDeviceTourData();
      this.getContractRemind();
      this.getAnnualExamineRemind();
      this.getRealTimeFollowList();
      this.getLiftageData();
      this.getWarningandTiringMapData();
      this.getDateMaintainRecordDate();
      this.getRescueProgressData();
      this.getRunTimeStatData();
    },
    $browserWidthChange() {
      this.getFollowItemScrollHeight();
      this.pieChart && this.pieChart.resize();
      this.liftageChart && this.setLiftageCustomData(true);
      this.map && this.setMapRender(true);
    },
    transformFontSize(fontsize) {
      const width = this.screenWidth;
      const ratio = width / 1920;
      return parseInt(fontsize * ratio);
    },
    /* getCurrentOrRestDate(date) {
      date = date || dayjs();
      function addZero(num) {
        if (num < 10 && num > 0) {
          return "0" + num;
        } else return num;
      }
      function getMonths(date, originalDate) {
        originalDate = originalDate || date;
        let daysInMonth = date.daysInMonth();
        let arrDays = [];
        while (daysInMonth) {
          let current = dayjs(
            String(date.$y) + addZero(date.$M + 1) + addZero(daysInMonth)
          );
          arrDays.push({
            planOrFinish: [0, 0],
            date: current.format("YYYY-MM-DD"),
            dZero: addZero(current.$D),
            d: String(current.$D),
            w: String(current.$W),
            notNow: date.$y + date.$M != originalDate.$y + originalDate.$M,
          });
          daysInMonth--;
        }
        return arrDays.reverse();
      }
      function getDaysArrayByMonth(date) {
        const themonth = getMonths(date);
        let lacknum = themonth[0].w;
        if (lacknum != 0) {
          let lastmonth = getMonths(date.add(-1, "months"), date);
          for (let i = 0; i < lacknum; i++) {
            themonth.unshift(lastmonth[lastmonth.length - 1 - i]);
          }
        }
        if (themonth.length < 6 * 7) {
          let little = 6 * 7 - themonth.length;
          let proximo = getMonths(date.add(1, "months"), date);
          for (let i = 0; i < little; i++) {
            themonth.push(proximo[i]);
          }
        }
        return themonth;
      }
      return {
        y: String(date.year()),
        m: addZero(date.month() + 1),
        d: addZero(date.date()),
        ds: getDaysArrayByMonth(date),
        activateDate: dayjs().format("YYYYMMDD"),
        $DATE: date,
      };
    }, */
    setRunTimePieData() {
      let chartDom = document.getElementById("degree-pie-id");
      this.pieChart = this.pieChart || echarts.init(chartDom);
      let option = {
        tooltip: {
          show: true,
          trigger: "item",
          confine: true,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["46%", "74%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
            },
            emphasis: {
              disabled: false,
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              borderWidth: this.transformFontSize(2),
              borderColor: "#1a1a2e",
            },
            data: this.runTimePieData,
          },
          {
            name: "",
            type: "pie",
            radius: ["46%", "63%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
            },
            emphasis: {
              disabled: false,
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: "rgba(8, 10, 32,0.7)",
                },
              },
            ],
          },
          {
            name: "",
            type: "pie",
            radius: ["46%", "55%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
            },
            emphasis: {
              disabled: false,
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: "rgba(8, 10, 32,0.5)",
                },
              },
            ],
          },
        ],
      };
      option && this.pieChart.setOption(option);
    },
    changeCalenderDate(date) {
      this.calenderDate = this.$common.getCurrentOrRestDate(dayjs(date));
      this.getDateMaintainRecordDate();
    },
    changeDate(step) {
      if (step) {
        this.calenderDate = this.$common.getCurrentOrRestDate(
          this.calenderDate.$DATE.add(1, "months")
        );
        this.getDateMaintainRecordDate();
      } else {
        this.calenderDate = this.$common.getCurrentOrRestDate(
          this.calenderDate.$DATE.add(-1, "months")
        );
        this.getDateMaintainRecordDate();
      }
      this.datePickerValue = this.calenderDate.$DATE.$d;
    },
    setLiftageCustomData(resize) {
      let unit = this.$l("台");
      let dataArr = [
        this.$l("0~3年"),
        this.$l("3~6年"),
        this.$l("6~10年"),
        this.$l("10~15年"),
        this.$l("15年以上"),
        this.$l("未知"),
      ];
      dataArr = dataArr.map((t, i) => {
        return {
          name: t,
          num: this.liftageData[i],
        };
      });
      let TData = dataArr.map((item) => Number(item.num));
      let option = {
        grid: {
          left: "5%",
          right: "5%",
          top: "18%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: {
          formatter: "{b}: {c}" + unit,
        },
        xAxis: {
          type: "category",
          data: dataArr.map((item) => item.name),
          axisLabel: {
            show: true,
            interval: 0,
            color: "#CCD9FF",
            fontSize: this.transformFontSize(14),
            align: "center",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#43567C",
              width: 0.6,
            },
          },
        },
        yAxis: {
          show: false,
          type: "value",
          scale: false,
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top",
                distance: this.transformFontSize(10),
                fontSize: this.transformFontSize(16),
                fontFamily: "DINPro",
                fontWeight: "500",
                color: "#87B9FF",
              },
            },
            barWidth: this.transformFontSize(16),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#7ED1EF",
                },
                {
                  offset: 1,
                  color: "#2B5DC0",
                },
              ]),
            },
            data: TData,
          },
        ],
      };
      let chartDom = document.getElementById("liftage-custom-box");
      this.liftageChart = this.liftageChart || echarts.init(chartDom);
      option && this.liftageChart.setOption(option);
      resize && this.liftageChart.resize();
    },
    setMapRender(resize) {
      return loadBMap().then((BMap) => {
        let map = new BMap.Map("tiring-map-box", {
          style: {
            styleJson: [
              {
                featureType: "land",
                elementType: "geometry",
                stylers: { color: "#15173Dff" },
              },
              {
                featureType: "water",
                elementType: "geometry",
                stylers: { color: "#0a1a40ff" },
              },
              {
                featureType: "green",
                elementType: "geometry",
                stylers: { color: "#102047ff" },
              },
              {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: { color: "#1e3a70ff" },
              },
              {
                featureType: "fourlevelway",
                elementType: "geometry.fill",
                stylers: { color: "#0e2250ff" },
              },
              {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: { color: "#2b4d8aff" },
              },
              {
                featureType: "building",
                elementType: "geometry",
                stylers: { color: "#16295cff" },
              },
              {
                featureType: "local",
                elementType: "geometry.fill",
                stylers: { color: "#0e2250ff" },
              },
              {
                featureType: "boundary",
                elementType: "geometry",
                stylers: { color: "#67c8ff66" },
              },
              // {
              //   featureType: "label", // 行政区名称
              //   elementType: "all",
              //   stylers: { visibility: "off" },
              // },
            ],
          },
        });
        // 创建多个图层并添加到地图
        if (this.rangeType == 0) {
          PROVINCES.forEach((province, index) => {
            this.setSingleDistrict(map, province, 0);
            // if (coords) {
            //   const label = new BMap.Label(province, {
            //     position: new BMap.Point(coords[0], coords[1]),
            //     offset: new BMap.Size(0, 0),
            //   });
            //   label.setStyle({
            //     color: "#ffffff",
            //     fontSize: "14px",
            //     fontWeight: "bold",
            //     fontFamily: "微软雅黑",
            //     backgroundColor: "rgba(0,0,0,0.3)",
            //     padding: "2px 8px",
            //     borderRadius: "4px",
            //   });
            //   map.addOverlay(label);
            // }
          });
          map.centerAndZoom(new BMap.Point(104.195, 35.8617), 5);
        } else {
          this.setSingleDistrict(map, this.districtName, 1);
          const myGeo = new BMap.Geocoder();
          myGeo.getPoint(this.districtName, (point) => {
            if (point) {
              map.centerAndZoom(new BMap.Point(point.lng, point.lat), 7);
            }
          });
        }
        this.setMarker(
          map,
          this.mapTiringData,
          require("../../assets/img/largeScreen/legend_point_01.png")
        );
        this.setMarker(
          map,
          this.mapWarningData,
          require("../../assets/img/largeScreen/legend_point_02.png")
        );
        return { map, BMap };
      });
    },
    setSingleDistrict(map, districtName, kind) {
      const layer = new BMap.DistrictLayer({
        name: districtName,
        fillOpacity: 0,
        fillColor: "#395ADD", // 每个省份都可以有自己的颜色
        strokeColor: "#81A6E5", // 边界颜色生效
        kind: kind,
      });
      // 鼠标移入：显示填充颜色
      layer.addEventListener("mouseover", function (e) {
        this.setFillOpacity(0.6);
      });
      // 鼠标移出：恢复透明
      layer.addEventListener("mouseout", function (e) {
        this.setFillOpacity(0);
      });
      map.addLayer(layer);
    },
    setMarker(map, datas, iconUrl) {
      datas.forEach((data, index) => {
        var icon = new BMap.Icon(iconUrl, new BMap.Size(32, 32));
        const marker = new BMap.Marker(
          new BMap.Point(data.value[0], data.value[1]),
          {
            icon: icon,
          }
        );
        marker.addEventListener("mouseover", () => {
          this.showCustomInfo(map, marker, data);
        });
        marker.addEventListener("mouseout", () => {
          this.hideCustomInfo();
        });
        map.addOverlay(marker);
      });
    },
    showCustomInfo(map, marker, data) {
      const pixel = map.pointToOverlayPixel(marker.getPosition());
      const info = document.getElementById("custom-map-info");
      info.innerHTML = `
        <span>${this.$l("省份")}：${data.province ? data.province : ""}</span>
        <span>${this.$l("城市")}：${data.name ? data.name : ""}</span>
        <span>${this.$l("地盘")}：${
        data.domainName ? data.domainName : ""
      }</span>
      `;
      info.style.display = "flex";
      info.style.left = pixel.x + 8 + "px";
      info.style.top = pixel.y - info.offsetHeight - 6 + "px";
    },
    hideCustomInfo() {
      document.getElementById("custom-map-info").style.display = "none";
    },
    /* 获取无纸化保养记录 */
    getDateMaintainRecordDate() {
      const cacheKey = "maintainDataCache";
      const cacheData = sessionStorage.getItem(cacheKey);
      if (cacheData) {
        const values = cacheData.split("#");
        if (values[1] == this.$common.formatDate(this.calenderDate.$DATE.$d)) {
          this.calenderDate.ds = JSON.parse(values[0]);
          return;
        } else {
          sessionStorage.removeItem(cacheKey);
        }
      }
      this.calendarLoading = true;
      this.$http
        .post(this.$apiConfig.get_elevator_maintain_record_date_url, {
          startDate: this.calenderDate.ds[0].date,
          endDate: this.calenderDate.ds[this.calenderDate.ds.length - 1].date,
        })
        .then((response) => {
          let result = response.data;
          this.calendarLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          data.forEach((v) => {
            let index = this.calenderDate.ds.findIndex((t) => t.date == v.date);
            if (index != -1) {
              this.calenderDate.ds[index].planOrFinish = v.values;
            }
          });
          sessionStorage.setItem(
            cacheKey,
            JSON.stringify(this.calenderDate.ds) +
              "#" +
              this.$common.formatDate(this.calenderDate.$DATE.$d),
            { expires: 1 }
          );
        })
        .catch((error) => {
          this.calendarLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取遥监设备状态 */
    statisticsMonitorStatusCount() {
      this.$http
        .post(this.$apiConfig.statistics_device_status_count_url, {
          type: 2,
        })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let monitorStatusArr = result.data;
          let tol = 0;
          monitorStatusArr.forEach((t) => {
            if (Number(t.name) == 1) {
              this.monitorStatusData.normal.value = t.value;
            } else this.monitorStatusData.abnormal.value = t.value;
            tol += Number(t.value);
          });
          const { normal, abnormal } = this.monitorStatusData;
          let normalC = (normal.value / tol) * 100;
          let abnormalC = (abnormal.value / tol) * 100;
          this.monitorStatusData.normal.centage = normalC.toFixed(2) + "%";
          this.monitorStatusData.abnormal.centage = abnormalC.toFixed(2) + "%";
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取遥监预警排行 */
    getMonitorWarningTop() {
      this.warningtopLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_yesterdy_stop_fault_count_url, {
          pageNum: 1,
          pageSize: 20,
          statisticType: 1,
        })
        .then((response) => {
          let result = response.data;
          this.warningtopLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data.result;
          data.length = data.length > 3 ? 3 : data.length;
          this.monitorWarningTop3 = data.map((t) => {
            return {
              city: t.city,
              liftCount: t.liftCount,
              domainName: t.domainName,
              faultCount: t.faultCount,
              domainId: t.domainId,
            };
          });

          //test数据 start
          // this.monitorWarningTop3 = [
          //   {
          //     city: "广州市",
          //     liftCount: "30",
          //     domainName: "千禧豫园9区",
          //     faultCount: "2912",
          //     domainId: "2719028",
          //   },
          //   {
          //     city: "广州市",
          //     liftCount: "30",
          //     domainName: "千禧豫园9区",
          //     faultCount: "2912",
          //     domainId: "2719028",
          //   },
          //   {
          //     city: "广州市",
          //     liftCount: "30",
          //     domainName: "千禧豫园9区",
          //     faultCount: "2912",
          //     domainId: "2719028",
          //   },
          // ];
          //test数据 end
        })
        .catch((error) => {
          this.warningtopLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取设备巡视总汇 */
    getDeviceTourData() {
      this.$http
        .post(this.$apiConfig.statistics_elevator_status_count_url, { type: 1 })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          data.forEach((t) => {
            let i = this.deviceCollects.findIndex((v) => v.type == t.name);
            if (i != -1) {
              this.deviceCollects[i].number = t.value;
            }
          });
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取合同提醒 */
    getContractRemind() {
      this.contractLoading = true;
      this.$http
        .post(this.$apiConfig.search_contract_expire_list_url, {
          pageNum: 1,
          pageSize: 12,
          curDate: this.$common.formatDate(new Date()),
          expiryInterval: 3 * 30,
        })
        .then((response) => {
          let result = response.data;
          this.contractLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data.result;
          this.contractRemindList = data.map((v) => {
            return {
              agreeNum: v.agreeNum,
              city: v.city,
              domainName: v.domainName,
              utils: v.utils,
              days: v.days,
            };
          });
          //test数据 start
          // this.contractRemindList = [
          //   {
          //     agreeNum: "AH2306100",
          //     city: "广州市",
          //     domainName: "天河区升辉府小区",
          //     utils: "2",
          //     days: "2",
          //   },
          //   {
          //     agreeNum: "AH2306100",
          //     city: "广州市",
          //     domainName: "天河区升辉府小区",
          //     utils: "2",
          //     days: "2",
          //   },
          //   {
          //     agreeNum: "AH2306100",
          //     city: "广州市",
          //     domainName: "天河区升辉府小区",
          //     utils: "2",
          //     days: "2",
          //   },
          //   {
          //     agreeNum: "AH2306100",
          //     city: "广州市",
          //     domainName: "天河区升辉府小区",
          //     utils: "2",
          //     days: "2",
          //   },
          // ];
          //test数据 end
        })
        .catch((error) => {
          this.contractLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取年检提醒 */
    getAnnualExamineRemind() {
      this.annualLoading = true;
      this.$http
        .post(this.$apiConfig.search_year_cheak_list_url, {
          pageNum: 1,
          pageSize: 12,
          curDate: this.$common.formatDate(new Date()),
          expiryInterval: 3 * 30,
        })
        .then((response) => {
          let result = response.data;
          this.annualLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data.result;
          this.annualExamineRemindList = data.map((v) => {
            return {
              agreeNum: v.agreeNum,
              city: v.city,
              domainName: v.domainName,
              utils: v.utils,
              domainId: v.domainId,
            };
          });
        })
        .catch((error) => {
          this.annualLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取实时关注列表 */
    getRealTimeFollowList() {
      this.$http
        .post(this.$apiConfig.search_real_elevator_fault_url, {})
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          this.realTimeFollowList = data.map((t) => {
            return {
              ...t,
              time: dayjs(t.updateTime).format("HH:mm"),
              domainName:
                t.domainName.trim().length > 15
                  ? t.domainName.substring(0, 15) + "..."
                  : t.domainName,
            };
          });
          this.getFollowItemScrollHeight(1);
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    getFollowItemScrollHeight(type) {
      this.$nextTick(() => {
        // this.$refs.realtimeScroll?._stopMove();
        let scroll = document.getElementsByClassName("realtime-info-item");
        if (scroll && scroll.length != 0 && [undefined, 1].includes(type)) {
          let height = scroll[0]?.getBoundingClientRect()?.height;
          // for (let i = 0; i < scroll.length; i++) {
          //   if (scroll[i].offsetHeight > height) {
          //     console.log(scroll[i]);
          //     height = scroll[i].offsetHeight;
          //   }
          // }
          this.singleRealtimeHeight = height;
          console.log("singleRealtimeHeight", this.singleRealtimeHeight);
          // this.$refs.realtimeScroll?._startMove();
          //error vue-seamless-scroll
        }
        let mapScroll = document.getElementsByClassName("warning-map-item");
        if (
          mapScroll &&
          mapScroll.length != 0 &&
          [undefined, 2].includes(type)
        ) {
          let heightScroll = mapScroll[0]?.getBoundingClientRect()?.height;
          this.singleMapHeight = heightScroll;
          console.log("singleMapHeight", this.singleMapHeight);
        }
      });
    },
    /* 获取梯龄分布 */
    getLiftageData() {
      let liftAge = sessionStorage.getItem("elevatorAgeBarData");
      if (liftAge) {
        const arr = liftAge.split("#");
        if (arr[0] == this.$common.formatDate()) {
          this.liftageData = JSON.parse(arr[1]);
          this.setLiftageCustomData();
          return;
        } else {
          sessionStorage.removeItem("elevatorAgeBarData");
        }
      }
      this.$http
        .post(this.$apiConfig.statistics_elevator_age_count_url, {
          curDate: this.$common.formatDate(new Date()),
        })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          this.liftageData = data;
          this.setLiftageCustomData();
          sessionStorage.setItem(
            "elevatorAgeBarData",
            this.$common.formatDate() + "#" + JSON.stringify(data)
          );
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取地图数据 */
    getWarningandTiringMapData(isNoLoading) {
      if (!isNoLoading) this.mapLoading = true;
      this.$store.state.indexMapTimer = setTimeout(() => {
        this.getWarningandTiringMapData(true);
      }, window.config.displayScreenCloseTimerInterval);
      this.$http
        .get(this.$apiConfig.statistics_fault_map_url)
        .then((response) => {
          let result = response.data;
          this.mapLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          let { partData, allData, rangeType, province, city } = data;
          this.mapTiringData = partData
            .filter((t) => t.processType)
            .map((v) => {
              return {
                name: v.city,
                value: [v.longitude, v.latitude],
                domainName: v.domainName,
                province: v.province,
              };
            });
          this.mapWarningData = partData
            .filter((t) => !t.processType)
            .map((v) => {
              return {
                name: v.city,
                value: [v.longitude, v.latitude],
                domainName: v.domainName,
                province: v.province,
              };
            });
          this.rangeType = rangeType;
          if (rangeType == 1) {
            this.districtName = province;
          } else if (rangeType == 2) {
            this.districtName = city;
          }
          this.mapAllCicyData = Object.keys(allData)
            .map((v) => {
              let n = v;
              if (rangeType) {
                let mapaArr = v.split(",");
                n = mapaArr[mapaArr.length - 1];
              }
              return {
                name: n,
                value: allData[v],
              };
            })
            .sort((a, b) => a.value - b.value);
          this.mapAllCicyData = Array.from(new Set([...this.mapAllCicyData]));
          this.showWarnings && this.openShowWarning();
          this.$nextTick(() => {
            this.setMapRender();
          });
        })
        .catch((error) => {
          console.log(error);
          this.mapLoading = false;
          this.$sentry.captureException(error);
        });
    },
    openShowWarning() {
      this.showWarnings = true;
      this.getFollowItemScrollHeight(2);
      this.mapAllScrollData = this.mapAllCicyData;
    },
    cancelShowWarning() {
      this.showWarnings = false;
      this.mapAllScrollData = [];
    },
    /* 获取今日救援进度 */
    getRescueProgressData() {
      this.$http
        .post(this.$apiConfig.get_elevator_rescue_progress_url)
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          const { maintain, rescue, rescueCompleteTime } = data;
          let maintainProgress = [
            1,
            1,
            maintain[0] ? Number((maintain[2] / maintain[0]).toFixed(2)) : 1,
            maintain[0] ? Number((maintain[3] / maintain[0]).toFixed(2)) : 1,
          ];
          let rescueProgress = [
            1,
            1,
            rescue[0] ? Number((rescue[2] / rescue[0]).toFixed(2)) : 1,
            rescue[0] ? Number((rescue[3] / rescue[0]).toFixed(2)) : 1,
          ];
          this.rescueProgress.maintain.number = maintain;
          this.rescueProgress.maintain.progress = maintainProgress;
          this.rescueProgress.rescue.number = rescue;
          this.rescueProgress.rescue.progress = rescueProgress;
          if (rescueCompleteTime) {
            this.progressText2[3] = "已救出";
          } else {
            this.progressText2[3] = "已完工";
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取运行次数分布统计 */
    getRunTimeStatData() {
      this.$http
        .post(this.$apiConfig.get_run_times_distribute_url)
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          this.runTimePieData.forEach((t, i) => {
            t.value = data[`count${i + 1}`];
          });
          this.setRunTimePieData();
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
  },
  beforeDestroy() {
    window.clearTimeout(this.$store.state.indexMapTimer);
    this.$store.state.indexMapTimer = -1;
  },
};
</script>

<style scoped lang="scss">
.tip {
  min-width: 180px;
  width: vw(180);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .en-end {
    display: flex;
    span:last-child {
      flex: 1;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  p {
    .en-class {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }

    text-align: right;
    width: 100%;
    position: relative;
    font-size: 1.125rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 500;
    font-style: italic;
    color: #d1d6df;
    padding-bottom: 10px;
    background: linear-gradient(0deg, #acddff 0%, #ffffff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    // text-shadow: 1px 1px 1px #ddd;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../../assets/img/largeScreen/largeScreenTip.png) no-repeat;
    }
  }
}
.tip-plus {
  width: 100%;
  p {
    text-align: left;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
  }
  .en-class {
    width: auto !important;
  }
  p::after {
    background-image: url(../../assets/img/largeScreen/largeScreenTipPlus.png);
  }
}
.tip-plus-bottom {
  width: 100% !important;
  p {
    height: vh(40);
    text-align: left;
    padding-left: 40px;
    line-height: 40px;
    padding-bottom: 0;
    font-family: AlibabaPuHuiTi;
    font-size: 1.5rem;
    font-weight: 700;
    font-style: italic;
    color: #f6f9fe;
    background-image: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  p::after {
    background-image: url(../../assets/img/largeScreen/largeScreenTipLBootom.png);
  }
}
.tip-right {
  p {
    padding-right: 20px;
  }
  span {
    float: right;
    font-size: 1rem;
  }
  i {
    font-size: 1rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #b2d76a;
    -webkit-text-fill-color: #b2d76a;
    font-style: initial;
  }
}
.screen-main {
  flex: 1;
  min-height: 10px;
  position: relative;
  // background: url(../../assets/img/largeScreen/largeScreenMapBgc.png) no-repeat;
  // background-size: 100% 100%;
  display: flex;
  padding: vh(18) vw(20) 0 vw(20);
  gap: vw(20);
}

.main-left {
  width: vw(434);
  padding-bottom: vh(20);
  display: flex;
  flex-direction: column;
}

.main-left-tsec {
  flex: 1;
  min-height: 10px;
  display: flex;
}
.main-right {
  width: vw(520);
  display: flex;
  flex-direction: column;
}
.main-map {
  height: 100%;
  flex: 1;
  min-width: 10px;
  display: flex;
  flex-direction: column;
}
.main-map-fsec {
  // height: vh(150);
  padding-bottom: vh(20);
  display: flex;
  gap: vw(20);
  > div {
    flex: 1;
    min-width: 10px;
  }
}
.maintain-record {
  .change {
    display: flex;
    margin-left: vw(16);
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        font-size: vw(12);
        font-weight: bold;
        padding: 0 0.5em;
        color: var(--bs-color-text-secondary);
      }
      span {
        cursor: pointer;
        font-size: vw(14);
        // font-family: DINPro;
        font-weight: 500;
        // margin: 0 vw(10);
        color: var(--bs-color-text-regular);
        position: relative;
      }
      .svg-icon {
        fill: #c6dcee;
        width: 1rem;
        height: 1rem;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .already {
    display: flex;
    margin-right: vw(22);
    gap: vw(14);
    font-size: vw(14);
    font-weight: 500;
    color: var(--bs-color-text-regular);
    span {
      &::before {
        content: "";
        width: vw(4);
        height: vw(4);
        border: 2px solid var(--bs-color-em);
        border-radius: 50%;
        margin-right: 0.2em;
        display: inline-block;
      }
    }
    span:last-child {
      &::before {
        border-color: var(--bs-color-warning);
      }
    }
  }
  .calendar {
    margin: 0 vw(8);
    position: relative;
    height: vh(430);
    background: rgba(8, 10, 32, 0.3);
    box-shadow: 0 vw(8) vw(20) 0 rgba(56, 99, 233, 0.2),
      inset 0 0 vw(30) 0 rgba(61, 112, 255, 0.5);
    border-radius: vw(8);
    display: flex;
    flex-direction: column;
    &:before {
      content: "";
      position: absolute;
      z-index: 2;
      pointer-events: none;
      inset: 0;
      border-radius: vw(8);
      padding: 1.5px;
      background: rgba(224, 245, 255, 0.3);
      background: linear-gradient(135deg, #b7c8ff, #5468d8, #a2abde);
      -webkit-mask: -webkit-gradient(
            linear,
            left top,
            left bottom,
            color-stop(0, #fff)
          )
          content-box,
        -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff));
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff))
          content-box,
        -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff));
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }
    .calendar-title {
      position: relative;
      height: vh(38);
      margin-top: vh(10);
      background-image: linear-gradient(
        270deg,
        rgba(87, 108, 244, 0) 0%,
        rgba(50, 57, 177, 0.5) 51%,
        rgba(87, 108, 244, 0) 100%
      );
      display: flex;
      justify-content: space-around;
      align-items: center;
      &:after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: linear-gradient(
          to right,
          rgba(#427ef2, 0),
          #829dee,
          rgba(#427ef2, 0)
        );
      }
      span {
        // font-family: JiangChengXieHei;
        font-weight: bold;
        color: #acbbf6;
        font-size: 0.75rem;
      }
    }
    .calendar-table {
      flex: 1;
      // display: flex;
      // flex-wrap: wrap;
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      padding: vw(6) vw(10) vw(10);
      grid-gap: vw(8);
      .activate {
        position: relative;
        border: 1px solid rgba(56, 99, 233, 0.65);
        box-shadow: inset 0 0 1em 0 rgba(56, 99, 233, 0.65);
        &:before,
        &:after {
          content: "";
          background: linear-gradient(
            to right,
            rgba(#427ef2, 0),
            #a1b9ff,
            rgba(#427ef2, 0)
          );
          height: 1.5px;
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
        &:after {
          top: auto;
          bottom: 0;
        }
        i {
          color: #ffffff;
          text-shadow: 0 0 0.4em #3863e9;
        }
      }
    }
    .calendar-item {
      // width: 14.2857%;
      // padding-left: vw(10);
      // padding-top: vh(10);
      justify-content: center;
      display: flex;
      flex-direction: column;

      background-image: linear-gradient(
        180deg,
        rgba(20, 23, 68, 0.5) 0%,
        rgba(43, 70, 130, 0.4) 100%
      );
      border: 1px solid rgba(56, 99, 233, 0.38);
      border-radius: vw(2);
      text-align: center;
      i {
        font-size: 1rem;
        font-weight: 500;
        font-style: initial;
        // font-family: DINCond-BoldAlternate;
        // font-family: DINPro;
        color: var(--bs-color-text-regular);
      }
      span {
        font-family: DINPro;
        font-weight: 500;
        // font-size: 1.25rem;
        font-size: 0.875rem;
        color: var(--bs-color-warning);
        position: relative;
        bottom: vh(-3);
      }
      em {
        color: var(--bs-color-em);
        &:after {
          content: "/";
          color: rgba(#fff, 0.3);
        }
      }
    }
    .ash {
      background: none;
      border: 1px solid rgba(56, 99, 233, 0.2);
      i {
        color: rgba(#fff, 0.3);
      }
      span {
        opacity: 0;
      }
    }
  }
}
.degree-pie {
  margin: vh(15) 0 vh(12);
  display: flex;
  flex-direction: column;
  .pie {
    height: vh(180);
    display: flex;
    align-items: center;
    margin: vh(5) vw(8) 0;
    background: url(../../assets/img/largeScreen/runPie_bg.png) no-repeat center;
    background-size: contain;
    gap: vw(8);
  }
  .pie-box {
    width: vh(180);
    height: vh(180);
    position: relative;
    & > div {
      z-index: 2;
    }
    // &::after {
    //   z-index: 1;
    //   content: "";
    //   position: absolute;
    //   width: vh(100);
    //   height: vh(100);
    //   top: 50%;
    //   left: 50%;
    //   transform: translate(-49.5%, -50%);
    //   background: url(../../assets/img/largeScreen/largeScreenMapPieBorder.png)
    //     no-repeat;
    //   background-size: 100%;
    // }
  }
  .degree-label {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: vh(14);
    div {
      position: relative;
      font-size: vw(14);
      // font-family: AlibabaPuHuiTi;
      // font-weight: 400;
      color: var(--bs-color-text-regular);
      // padding: 0 vw(10) 0 vw(15);
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      padding-left: vw(18);
      &:nth-child(2n) {
        margin-left: vw(32);
      }
    }
    i {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      width: vh(4);
      height: vh(20);
      border-radius: 10em;
    }
    em {
      font-size: 1.12em;
      font-family: DINPro;
      font-weight: 500;
      color: #ffffff;
      text-shadow: 0 0 0.5em #3863e9;
    }
    p {
      color: rgba(#fff, 0.4);
    }
    &--left {
      text-align: right;
      justify-content: flex-end;
      div {
        padding-left: 0;
        padding-right: vw(18);
        &:nth-child(2n) {
          margin-left: 0;
          margin-right: vw(32);
        }
      }
      i {
        right: 0;
        left: auto;
      }
    }
  }
}
.device-state {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.percentage {
  flex: 1;
  flex-basis: 0;
  // height: vh(65);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 vw(8);
  .item-normal {
    padding-right: vw(20);
  }
  .item-abnormal {
    padding-right: vw(20);
    &::before {
      background-image: url(../../assets/img/largeScreen/abnormalIcon.png) !important;
    }
    span:first-child s {
      color: #f39664;
    }
  }
  .item-normal,
  .item-abnormal {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 50%;
    &::before {
      content: "";
      width: vh(75);
      height: vh(75);
      background: url(../../assets/img/largeScreen/monitoIcon.png) no-repeat;
      background-size: 100%;
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 1rem;
      color: #cedce6;
      span:last-child s {
        color: #798f9a;
      }
      i {
        font-style: normal;
      }
      s {
        text-decoration: none;
        font-size: 1.125rem;
        font-family: DINPro;
        color: #00dca6;
        margin-left: 5px;
      }
    }
  }
}
.monitoring-top {
  height: vh(143);
  display: flex;
  flex-direction: column;
  .top-list {
    margin-top: vh(5);
    overflow-y: auto;
    width: 95%;
    margin: auto;
    flex: 1;
    min-height: 10px;
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: vh(30);
      // font-family: AlibabaPuHuiTi;
      // font-weight: 400;
      // font-style: normal;
      font-size: 0.75rem;
      color: var(--bs-color-text-regular);
      padding: 0 vw(10);
      background: rgba(10, 16, 61, 0.5);
      &:nth-child(2n) {
        background: rgba(40, 63, 131, 0.35);
      }
      h5 {
        color: var(--bs-color-info);
        font-weight: 500;
      }
      span {
        flex: 1;
        text-align: left;
        padding-left: vw(20);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      i {
        font-style: normal;
        color: var(--bs-color-info);
        b {
          font-weight: 500;
          font-family: DINPro;
          font-size: 1.125em;
          margin-right: 0.2em;
        }
      }
    }
    .no-data {
      height: 100%;
      justify-content: center;
    }
    @extend %scroll-bs;
  }
  .top-list-contract {
    // height: vh(110);
    // overflow-y: auto;
    div {
      span {
        flex: 0.85;
        padding: 0;
        display: flex;
        font-family: inherit;
        font-weight: inherit;
        font-style: inherit;
        color: inherit;
      }
      s {
        text-decoration: none;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .top-list-annual {
    em {
      padding-left: 8px;
      margin-left: 5px;
      position: relative;
      &::before {
        content: "|";
        position: absolute;
        left: 0;
        opacity: 0.3;
      }
    }
  }
}

.realtime-info {
  margin-top: vh(20);
  display: flex;
  flex-direction: column;
  .info-list {
    width: 95%;
    padding-top: vh(3);
    .realtime-info-item {
      height: vh(42);
      display: flex;
      flex-direction: column;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 0.875rem;
      font-style: italic;
      color: #b9ccdf;
      padding-right: 5px;
      div {
        height: 100%;
      }
    }

    span {
      color: #b9ccdf;
      opacity: 0.8;
      font-size: 0.75rem;
      text-align: right;
      float: right;
      margin-left: vw(60);
    }
  }
  .seamless-warp {
    height: vh(42);
    overflow: hidden;
  }
}
.map-fbox {
  flex: 1;
  min-height: 10px;
  position: relative;
  #tiring-map-box {
    width: 100%;
    height: 100%;
    background-image: initial !important;
    background-color: transparent;
    /deep/ .anchorBL {
      display: none;
    }
    .map-under {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      color: #b8c6d3;
      font-size: 1rem;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #b8c6d3;
    font-size: 1rem;
  }
  .warning-list-box {
    position: absolute;
    top: 0;
    left: vw(36);
    height: 95%;
  }
  .warning-map-list {
    height: 100%;
    width: vw(285);
    background: rgba(5, 25, 53, 0.45);
    border: 1px solid rgba(64, 252, 255, 0.3);
    box-shadow: 4px 7px 13px 0px rgba(2, 19, 31, 0.36);
    border-radius: 6px;
    padding: vh(20) vw(10) 0 vw(20);
    display: flex;
    flex-direction: column;
    .tip p {
      text-align: left;
      padding-left: 20px;
    }
    .warning-list {
      flex: 1;
      overflow-y: auto;
      padding-top: vh(10);
      // &::-webkit-scrollbar {
      //   display: none;
      // }
      // scrollbar-width: none;
      // -ms-overflow-style: none;
      .warning-map-item {
        font-family: AlibabaPuHuiTi;
        font-weight: 400;
        color: #b8c6d3;
        font-size: 1rem;
        padding: vh(5) 0 vh(5) vw(20);
        display: flex;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: vw(7);
          height: vw(7);
          background: rgba(20, 220, 232, 0.78);
          top: 50%;
          left: vw(2);
          transform: translate(0, -50%) rotate(45deg);
          box-shadow: 0px 0px 5px #14dce894;
        }
      }
      label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        flex-shrink: 0;
      }
    }
    .seamless-warning {
      height: 100%;
      overflow: hidden;
    }
    .footer {
      height: vh(40);
      i {
        float: right;
        width: vw(18);
        height: vh(25);
        background: url(../../assets/img/largeScreen/dropIcon.png) no-repeat;
        background-size: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &::before {
          content: "";
          display: inline-block;
          width: 1px;
          height: 1px;
          box-shadow: 0px 0px 20px 7px #14dce894;
        }
      }
    }
  }
  .suspension {
    width: vw(80);
    height: vw(80);
    background: url(../../assets/img/largeScreen/suspensionIcon.png) no-repeat;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #fff;
    font-size: 0.9375rem;
  }
  .tiring-map-label {
    position: absolute;
    right: vw(36);
    bottom: vh(54);
    div {
      height: vh(38);
      width: vw(103);
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(../../assets/img/largeScreen/legend_item.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    span {
      display: inline-block;
      width: vh(8);
      height: vh(8);
      border-radius: 10em;
      // background: url(../../assets/img/largeScreen/legend_point_01.png)
      //   no-repeat center;
      // background-size: contain;
      background: var(--bs-color-warning);
      box-shadow: 0 0 0 vh(4) rgba(#f9c62d, 0.2), 0 0 0 vh(2) rgba(#f9c62d, 0.5);
      z-index: 2;
      margin-right: 0.5em;
    }
    label {
      font-size: 1rem;
      font-weight: 500;
      color: var(--bs-color-text-regular);
      position: relative;
    }
    .tiring {
      span {
      }
      margin-bottom: vh(6);
    }
    .warning {
      span {
        background: var(--bs-color-danger);
        box-shadow: 0 0 0 vh(4) rgba(#fb5c5d, 0.2),
          0 0 0 vh(2) rgba(#fb5c5d, 0.5);
      }
    }
  }
}
#tiring-map-box {
  /deep/ .BMap_bubble_title,
  /deep/ .BMap_bubble_content {
    color: #d5e1ff !important;
    font-family: AlibabaPuHuiTi, "Microsoft YaHei";
  }
  /deep/ .BMap_bubble_content {
    font-size: 12px;
    line-height: 1.8;
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    li {
      white-space: nowrap;
      color: #ccd9ff;
    }
  }
  /deep/ .BMap_pop {
    background-color: rgba(13, 25, 66, 0.96) !important;
    background-image: none !important;
    border: 1px solid #3863e9 !important;
    border-radius: 8px;
    box-shadow: 0 0 20px 0 rgba(56, 99, 233, 0.45);
  }
  /deep/ .BMap_pop > div {
    background: transparent !important;
    background-image: none !important;
    border: none !important;
  }
}
.custom-map-info {
  position: absolute;
  z-index: 999;
  display: none;
  flex-direction: column;
  min-width: 150px;
  padding: 8px 12px;
  background: rgba(9, 24, 56, 0.95);
  border: 1px solid #3863e9;
  border-radius: 8px;
  box-shadow: 0 0 18px 0 rgba(56, 99, 233, 0.5),
    inset 0 0 12px 0 rgba(61, 112, 255, 0.25);
  font-family: AlibabaPuHuiTi, "Microsoft YaHei";
  color: #ccd9ff;
  font-size: 12px;
  line-height: 1.9;
  white-space: nowrap;
  pointer-events: none;
  span {
    display: block;
    line-height: 1.9;
  }
}
.mapAlarmList {
  flex: 1;
  min-width: 10px;
  margin-top: vh(36);
  margin-left: vw(12);
  margin-bottom: vw(58);
  font-size: vw(14);
  overflow: hidden;
  position: relative;

  border-radius: vw(8);
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(
    180deg,
    rgba(42, 63, 180, 0) 0%,
    rgba(83, 102, 204, 0) 11%,
    rgba(45, 69, 195, 0) 87%,
    rgba(42, 63, 180, 0.28) 100%
  );
  box-shadow: 0 vw(8) vh(12) 0 rgba(56, 99, 233, 0.15);
  &:before {
    content: "";
    position: absolute;
    z-index: 2;
    pointer-events: none;
    inset: 0;
    border-radius: vw(8);
    padding: 1px;
    background: rgba(224, 245, 255, 0.3);
    background: linear-gradient(
      135deg,
      rgba(#7698ff, 1) 0%,
      rgba(#394691, 1) 40%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
  &-h {
    position: relative;
    height: vh(30);
    margin-top: vh(14);
    margin-bottom: vh(14);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: vw(16);
    &:after {
      content: "";
      position: absolute;
      inset: 0;
      background: url(../../assets/img/largeScreen/mapAlarm_title_bg.png)
        no-repeat center;
      background-size: auto 100%;
    }
    h4 {
      position: relative;
      font-weight: bold;
      font-size: 1em;
      line-height: 1;
      color: transparent;
      text-shadow: 0 0.2em 0.4em rgba(0, 0, 0, 0.45), 0 0 0.5em #3863ee;
      &:after {
        content: attr(text);
        position: absolute;
        left: 0;
        z-index: 9;
        color: #ffffff;
        text-align: center;
        background-image: linear-gradient(to bottom, #b5cbff, #ffffff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: none;
      }
    }
  }
  .warning-list {
    flex: 1;
    min-height: 10px;
    // overflow-y: auto;
    overflow-y: hidden;
    padding: 0 1.8em 0 1.4em;
    color: var(--bs-color-text-regular);
  }
  .warning-map-item {
    display: flex;
    align-items: center;
    height: vh(36);
    &:before {
      content: "";
      display: inline-block;
      background: url(../../assets/img/largeScreen/mapLabelArrow.png) no-repeat;
      background-size: contain;
      width: vw(16);
      height: vw(14);
      margin-right: vw(8);
      flex-shrink: 0;
    }
    &__line {
      flex: 1;
      min-width: 10px;
      margin: 0 0.5em;
      overflow: hidden;
      color: var(--bs-color-text-regular);
      opacity: 0.4;
      &::before {
        content: "........................";
        position: relative;
        top: -0.25em;
      }
    }
    h4 {
    }
    p {
      color: var(--bs-color-info);
      em {
        font-size: 1.15em;
        font-family: DINPro;
        font-weight: 500;
        margin-right: 0.2em;
      }
    }
  }
}
.rescue-progress {
  width: vw(236);
  display: flex;
  flex-direction: column;
  .rescue-view {
    flex: 1;
    padding-bottom: vh(20);
    display: flex;
    flex-direction: column;
  }
  .rescue-items {
    flex: 1;
    min-height: 10px;
    display: flex;
    flex-direction: column;
    padding-top: vh(20);
  }
  .progress-box {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: vh(24) vw(16) vh(4) vw(12);
    text-align: center;
  }
  .bar-box {
    width: 100%;
    height: vh(104);

    background: url("../../assets/img/largeScreen/progressPie_bg.png") no-repeat
      center;
    background-size: auto 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .progress-bar {
    width: vh(58);
    height: vh(58);
    min-width: vh(58);
    min-height: vh(58);
    margin-top: vh(8);
  }
  .text {
    font-size: vw(14);
    font-weight: 400;
    color: var(--bs-color-text-regular);
    em {
      position: relative;
      top: 0.05em;
      font-size: 1.2em;
      font-family: DINPro;
      font-weight: 500;
      color: var(--bs-color-text-primary);
    }
  }
}
.tour-collect {
  display: flex;
  margin-bottom: vh(8);
  .collect-list {
    flex: 1;
    display: flex;
    padding: 0 vw(30);
  }
  .collect-item {
    flex: 1;
    // height: vh(65);
    display: flex;
    flex-direction: column;
    align-items: center;
    // margin-bottom: vh(10);
    overflow: hidden;
  }
  .collect-item-icon {
    margin-top: vh(12);
    width: vw(100);
    // height: vw(65);
    display: flex;
    justify-content: center;
    background: url(../../assets/img/largeScreen/collect_icon_bg.png) no-repeat
      center bottom;
    background-size: 100% auto;
  }
  .icon {
    width: vw(52);
    height: vw(52);
    background-size: 100%;
    background-repeat: no-repeat;
    margin-bottom: vw(28);
    flex-shrink: 0;
  }

  em {
    font-size: vw(24);
    font-family: DINPro;
    font-weight: 500;
    color: #fff;
    text-shadow: 0 0 0.6em #3863e9;
  }
  .number {
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: center;
    overflow-y: hidden;
    text-align: center;
    & > span {
      width: 100%;
      overflow: hidden;
      font-size: 1em;
      // font-family: AlibabaPuHuiTi;
      // font-weight: 500;
      // font-style: italic;
      color: #fff;
      position: relative;
      &::after {
        content: attr(data-title);
      }
    }
  }
}
.liftage-distribute {
  // margin: vh(15) 0;
  display: flex;
  flex-direction: column;
  .liftage-custom-box {
    height: vh(160);
  }
}
/deep/.custom-date-picker {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  &.el-input {
    width: 100%;
  }
  &.el-input--suffix {
    .el-input__inner {
      height: 100%;
    }
  }
  .el-input__inner {
    opacity: 0;
    padding: 0 !important;
    overflow: hidden;
  }
}

// /deep/ .date-screen {
//   background-color: #052139;
//   border-color: #1a364c;
//   .el-picker-panel__icon-btn {
//     color: #fff;
//   }
//   .popper__arrow {
//     border-bottom-color: #0f4b70;
//     &::after {
//       border-bottom-color: #0f4b70;
//     }
//   }
//   .cell {
//     color: #e0edfe;
//     font-size: 14px;
//     &:hover {
//       color: #2474bb;
//     }
//   }
//   .el-date-picker__header {
//     border-bottom: 0;
//     background-color: #0f4b70;
//     margin: 0;
//     padding: 10px;
//   }
//   .el-picker-panel__content {
//     margin: 0;
//     width: 100%;
//   }
//   .today {
//     background-color: #2474bb;
//     .cell {
//       color: #e0edfe;
//     }
//   }
//   .current {
//     .cell {
//       color: #e0edfe !important;
//     }
//   }
//   .el-date-picker__header-label {
//     color: #e0edfe;
//   }
// }
</style>
<style lang="scss">
.date-screen {
  background-color: rgba(13, 25, 66, 1);
  border-color: #21377f;
  .el-picker-panel__icon-btn {
    color: #fff;
  }
  .popper__arrow {
    border-bottom-color: #21377f !important;
    &::after {
      border-bottom-color: #21377f !important;
    }
  }
  .cell {
    color: #a5aee8 !important;
    font-size: 14px;
    &:hover {
      color: #2474bb;
    }
  }
  .el-date-picker__header {
    border-bottom: 0;
    background-color: #1a2455;
    margin: 0;
    padding: 10px;
    border-radius: 12px 12px 0 0;
  }
  .el-picker-panel__content {
    margin: 0;
    width: 100%;
  }
  .today {
    background-color: #3863e9;
    .cell {
      color: #fff !important;
    }
  }
  .current {
    .cell {
      color: #ecf0ff !important;
    }
  }
  .el-date-picker__header-label {
    color: #ccd9ff;
  }
}
</style>
